import { alpha, SxProps, Theme } from "@mui/material";

export const defaultButtonProps: SxProps<Theme> = {
  width: "100%",
  height: "100%",
  borderRadius: "12px",
  bgcolor: "primary.main",
  "&:hover": {
    bgcolor: "primary.light",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    border: (theme) => `1px solid ${theme.palette.primary.main}`,
  },
};

export const commonButtonProps: SxProps<Theme> = {
  borderRadius: "12px",
  bgcolor: "primary.main",
  minHeight: "44px",
  color: "white",
  fontSize: "14px",
  "&:hover": {
    bgcolor: (theme) => alpha(theme.palette.primary.light, 0.8),
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
  },
  "&.Mui-disabled": {
    bgcolor: (theme) => alpha(theme.palette.primary.light, 0.2),
    color: (theme) => theme.palette.text.disabled,
  },
  "&.MuiButton-loading": {
    bgcolor: (theme) => alpha(theme.palette.primary.light, 0.2),
    color: "transparent",
  },
};
